<template>
    <MainContainer>
        <div class="buchung position-relative">
            <h2>
                Spendenquittungen
            </h2>
            <b-form>
                <b-form-group
                    label-cols-sm="2"
                    label-for="inputYear"
                    :label-size="size"
                >
                    <template v-slot:label>
                        <template v-if="years.busy">
                            <ContentLoadingBlock class="inline" />
                        </template>
                        <template v-else>Gesamtes Abrechnungsjahr:</template>
                    </template>

                    <template v-if="years.busy">
                        <ContentLoadingBlock />
                    </template>
                    <template v-else>
                        <b-select
                            id="inputYear"
                            :options="years.options"
                            v-model="filter.year"
                            :size="size"
                        />
                    </template>
                </b-form-group>
                <b-form-group>
                    <div class="text-center small">oder</div>
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="Zeitraum von:"
                    label-for="inputFromDate"
                    :label-size="size"
                >
                    <b-datepicker
                        id="inputFromDate"
                        v-model="filter._from_date"
                        :disabled="disableDateFilter"
                        :size="size"
                    />
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="Zeitraum bis:"
                    label-for="inputToDate"
                    :label-size="size"
                >
                    <b-datepicker
                        id="inputToDate"
                        v-model="filter._to_date"
                        :disabled="disableDateFilter"
                        :size="size"
                    />
                </b-form-group>
                <hr />
                <b-form-group
                    label-cols-sm="2"
                    label-for="inputCols"
                    label="Sortierung:"
                    :label-size="size"
                >
                    <b-select
                        id="inputYear"
                        :options="sorting.options"
                        v-model="filter.sorting"
                        :size="size"
                    />
                </b-form-group>
                <hr />
                <b-form-group
                    label-cols-sm="2"
                    label-for="inputInfos"
                    label="Zusätzliche Informationen:"
                    :label-size="size"
                >
                    <b-checkbox :size="size" v-model="includeUnder100">
                        auch Spendenbescheinigungen bei Beträgen
                        <b>unter</b> 100 Euro ausgeben</b-checkbox
                    >
                    <b-checkbox :size="size" v-model="includeWithoutAddress">
                        auch Spendenbescheinigungen <b>OHNE</b> vollständige
                        Adresse ausgeben</b-checkbox
                    >
                </b-form-group>
                <hr />
                <b-form-group
                    label="Mitglieder-Auswahl"
                    label-cols-sm="2"
                    :label-size="size"
                    v-slot="{ ariaDescribedby }"
                >
                    <b-form-radio
                        v-model="selected"
                        :ariaDescribedby="ariaDescribedby"
                        name="mitglieder-radios"
                        :size="size"
                        value="all"
                    >
                        Alle Mitglieder
                    </b-form-radio>
                    <b-form-radio
                        v-model="selected"
                        :ariaDescribedby="ariaDescribedby"
                        name="mitglieder-radios"
                        :size="size"
                        value="stati"
                    >
                        Mitglieder mit best. Stati
                    </b-form-radio>
                    <b-form-radio
                        v-model="selected"
                        :ariaDescribedby="ariaDescribedby"
                        name="mitglieder-radios"
                        :size="size"
                        value="select"
                    >
                        Mitglieder nach Auswahl
                    </b-form-radio>
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label-for="inputInfos"
                    label="Mitgliederauswahl nach Stati:"
                    :label-size="size"
                >
                    <StatiMultiSelect
                        :size="size"
                        :disabled="disableStatiSelect"
                        v-model="selectedMitgliederStati"
                    />
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label-for="inputInfos"
                    label="Einzelauswahl Mitglieder:"
                    :label-size="size"
                >
                    <MitgliederMultiSelect
                        :size="size"
                        :disabled="disableMitgliederSelect"
                        v-model="selectedMitglieder"
                    />
                </b-form-group>
                <b-form-group>
                    <b-button variant="primary" @click="onSubmit" :size="size"
                        >Vorschau anzeigen</b-button
                    >
                    <b-button
                        variant="primary"
                        class="ml-1"
                        @click="onPrintSubmit"
                        :size="size"
                        >Anzeigen und als gedruckt markieren</b-button
                    >
                    <b-button
                        type="reset"
                        variant="outline-danger"
                        :size="size"
                        class="ml-1"
                        >Felder zurücksetzen</b-button
                    >
                </b-form-group>
            </b-form>
        </div>
        <PopUpChecker />
        <div
            class="loading-modal container-fluid d-flex justify-content-center align-items-center p-3"
            v-if="busy"
        >
            <div class="d-flex flex-column align-items-center">
                <h6 class="mb-3">Daten werden geladen. Bitte haben Sie etwas Geduld!</h6>
                <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
            </div>
        </div>
    </MainContainer>
</template>

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import Currency from "@/mixins/Currency/Currency";
import Validation from "@/mixins/Validation/Validation";
import { ApiFactory } from "@/api/ApiFactory.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import ContentLoadingBlock from "@/components/ContentLoadingBlock/ContentLoadingBlock";
import MitgliederMultiSelect from "@/components/MitgliederMultiSelect/MitgliederMultiSelect";
import StatiMultiSelect from "@/components/StatiMultiSelect/StatiMultiSelect.vue";
import { BlobUtil } from "../../utils/BlobUtil";
import PopUpChecker from "@/components/PopUpChecker/PopUpChecker.vue";

const FiBuBuchungApi = ApiFactory.get("fibuBuchung");
const FiBuSpendenquittungApi = ApiFactory.get("fibuSpendenquittung");

export default {
    name: "Spendenquittung",
    mixins: [CommonView, Size, Currency, Validation],
    components: {
        StatiMultiSelect,
        MainContainer,
        ContentLoadingBlock,
        MitgliederMultiSelect,
        PopUpChecker
    },
    data() {
        return {
            api: FiBuBuchungApi,
            prefetch: false,
            busy: false,
            fields: [],
            information: [],
            includeUnder100: false,
            includeWithoutAddress: false,
            mitglieder: null,
            selectedMitgliederStati: [],
            selectedMitglieder: [],
            selected: "all",
            markAsPrinted: false,
            filter: {
                _from_date: null,
                _to_date: null,
                year: null,
                sorting: "status, name"
            },
            years: {
                busy: false,
                items: [],
                options: []
            },
            sorting: {
                options: [
                    { value: "status, name", text: "Status, Name" },
                    { value: "name", text: "Name" },
                    { value: "plz, name", text: "PLZ, Name" }
                ]
            },
            disableDateFilter: false,
            disableMitgliederSelect: true,
            disableStatiSelect: true
        };
    },
    async created() {
        this.fetchBuchungsYears();

        this.filter.year = this.$moment()
            .format("Y");
    },
    watch: {
        filter: {
            handler() {}
        },
        "filter.year": {
            handler(val) {
                if (val) {
                    this.disableDateFilter = true;
                    this.filter._to_date = null;
                    this.filter._from_date = null;
                } else {
                    this.disableDateFilter = false;
                }
            }
        },
        selected: {
            handler(val) {
                switch(val) {
                    case "stati":
                        this.disableMitgliederSelect = true;
                        this.disableStatiSelect = false;
                        this.selectedMitglieder = [];
                        break;
                    case "select":
                        this.disableMitgliederSelect = false;
                        this.disableStatiSelect = true;
                        this.selectedMitgliederStati = [];
                        break;
                    default:
                        this.disableMitgliederSelect = true;
                        this.disableStatiSelect = true;
                        this.selectedMitglieder = [];
                        this.selectedMitgliederStati = [];
                }
            }
        }
    },
    methods: {
        async fetchSpendenquittung() {
            FiBuSpendenquittungApi.abort();

            this.busy = true;

            let filter = this.filter;
            if(!this.selectedMitgliederStati.length) {
                filter = Object.assign(filter, {
                    includeUnder100: this.includeUnder100,
                    includeWithoutAddress: this.includeWithoutAddress,
                    mitglieder: this.selectedMitglieder,
                    markAsPrinted: this.markAsPrinted
                });
            } else {
                filter = Object.assign(filter, {
                    includeUnder100: this.includeUnder100,
                    includeWithoutAddress: this.includeWithoutAddress,
                    stati: this.selectedMitgliederStati,
                    markAsPrinted: this.markAsPrinted
                });
            }

            const response = await FiBuSpendenquittungApi.get({
                filter
            });

            if(response.ok) {
                const hasPopUpBlocker = BlobUtil.openBlob(response.blob);
                if (hasPopUpBlocker) {
                    this.$bvModal.show('pop-up-checker');
                }
            }

            this.markAsPrinted = false;
            this.selectedMitgliederStati = [];
            this.selectedMitglieder = [];
            this.selected = "all";
            this.filter = {
                _from_date: null,
                _to_date: null,
                year: null,
                sorting: "status, name"
            };

            this.busy = false;
        },
        async fetchBuchungsYears() {
            this.years.busy = true;
            const response = await FiBuBuchungApi.getYears();
            if (response.ok) {
                this.years.items = response.json.collection;
                this.years.options = response.json.collection.map(item => {
                    return {
                        text: item,
                        value: item
                    };
                });
                this.years.options.unshift({
                    text: "Datum auswählen...",
                    value: null
                });
            }
            this.years.busy = false;
        },
        updateFilter(filter) {
            this.filter = Object.assign({}, filter);
        },
        postProcessCreate(selectedItem, response) {
            selectedItem.id = response.json.id;
            return selectedItem;
        },
        fetchErrorHandling(response) {
            this.handleValidationData(response, this.ioFields);
        },
        postDataSet() {
            this.cleanValidationData(this.ioFields);
        },
        async onSubmit(evt) {
            evt.preventDefault();
            await this.fetchSpendenquittung();
        },
        async onPrintSubmit(evt) {
            evt.preventDefault();
            this.markAsPrinted = true;
            await this.fetchSpendenquittung();
        },
        async getMitglieder(payload) {
            this.mitglieder = payload;
        }
    }
};
</script>
